import { RefreshCcw } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { DocumentStatus, type Document } from "~/api/model";
import { Loader } from "~/components/Loader";
import { LoaderRays } from "~/components/loader-rays";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

export const DocumentImageName = ({ document }: { document: Document }) => {
  const isQueued = !document.pageCount;
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(
          textRef.current.scrollWidth > textRef.current.clientWidth
        );
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);

    return () => {
      window.removeEventListener("resize", checkTruncation);
    };
  }, [document.filename]);

  const filenameElement = (
    <span
      ref={textRef}
      className="text-foreground text-sm font-medium leading-tight truncate min-w-0"
    >
      {document.filename}
    </span>
  );

  return (
    <div className="flex items-center justify-start gap-2 min-w-0">
      <div className="w-12 h-12 min-w-12 min-h-12 shrink-0 bg-muted rounded-md flex justify-center items-center">
        <div
          className={`w-12 h-12 min-w-12 min-h-12 rounded-md flex justify-center items-center`}
        >
          {document.status === DocumentStatus.ERROR ? (
            <RefreshCcw className="w-6 h-6 text-muted-foreground" />
          ) : document?.previewUrl ? (
            <img
              src={document?.previewUrl}
              className="h-full object-cover pt-2"
            />
          ) : isQueued ? (
            <LoaderRays
              isShowPng={true}
              className="w-6 h-6 animate-spin text-blue-600"
            />
          ) : (
            <Loader isShowPng={true} className="w-6 h-6 text-blue-600" />
          )}
        </div>
      </div>
      {isTruncated ? (
        <Tooltip>
          <TooltipTrigger asChild>{filenameElement}</TooltipTrigger>
          <TooltipContent>
            <p>{document.filename}</p>
          </TooltipContent>
        </Tooltip>
      ) : (
        filenameElement
      )}
    </div>
  );
};
